export default __webpack_public_path__ + "static/media/AMS.3296ebbf.jpeg";